import { Container, Row, Col } from "react-bootstrap";
import './finalValueScreen.scss'
import feelingBad from './assets/feeling_bad.svg'
import { Button } from 'sfy-react'
import pushToAnalytics from "./Analytics";
import { useEffect } from "react";
function DeviceNotEligible(props) {
 const { brand, model, variant, closeBtnClick } = props;
 useEffect(() => {
  pushToAnalytics(
   'Exchange Value - Device not eligible for exchange',
   {
    Brand: brand,
    Model: model,
    Variant: variant,
    Unique_Key:localStorage.getItem('ampleUniquekey')
   }
  )
 }, [])
 return (
  <Container fluid className="p-20 m-0 g-0" >
   <div>
    <Row>
     <Col xs={12}>
      <div className="tr-not-eligible-header">
       Device Not Eligible for Exchange
      </div>
      <div className="tr-not-eligible-sub-header">
       Sorry but your old device does not qualify for the exchange
      </div>
     </Col>
     <Col xs={12}>
      <div className="exchange-device-str" style={{ marginTop: '30px' }}>
       Exchange Device
      </div>
      <div className='tr-not-eliglrble-details'>
       {`${brand || ""} ${model || ""} | ${variant}`}
      </div>
     </Col>
    </Row>
    <Row>
     <Col xs={12} className='d-flex vertical-center horizontal-center'>
      <div style={{ padding: '38px' }}>
       <img className="feelingBadImage" src={feelingBad} alt='feeling Bad' />
      </div>
     </Col>
    </Row>
   </div>
   <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <Button type='button' text={'Close'} classes='close-secondary-btn'
     handleOnClick={closeBtnClick} >
    </Button>
   </div>
  </Container>
 );
}
export default DeviceNotEligible;